import { DeleteOutlined } from "@ant-design/icons";
import { Conversation, ConversationList } from "@chatscope/chat-ui-kit-react";
import { BasicResponseDTO } from "@dto/basicResponse.dto";
import { LLMHistory } from "@dto/llm.dto";
import { DateUtil } from "@dto/util/DateUtil";
import { Button, Modal, Popconfirm } from "antd";
import { FC, useContext, useEffect } from "react";
import { API_URL } from "src/data/Api";
import { Label } from "src/data/Label";
import { Log } from "src/service/log.service";
import { deleteApi } from "src/util/apiCalls";
import { ChatContext } from "./AIChat";
import { getChatHistory } from "./chatService";

export const AIChatHistory: FC = ({ ...props }) => {
  const { history, setHistory, setConversation, historyOpen, setHistoryOpen } = useContext(ChatContext);

  useEffect(() => {
    if (!historyOpen) return;
    void getChatHistory().then(response => {
      setHistory(response.data.data);
    });
  }, [historyOpen]);

  const switchToHistory = (lh: LLMHistory) => {
    setConversation(lh);
    setHistoryOpen(false);
  };

  function deleteConversation(topicId: number) {
    deleteApi<BasicResponseDTO>(API_URL.LLM + '/history/' + topicId).then(response => {
      setHistory(prev => prev.filter(lh => lh.topicId != topicId));
    }, reason => Log.error("Failed to delete topic ID " + topicId, reason));
  }

  return <Modal className="xm-chat-history"
    open={historyOpen} title={Label.XORBOT + ' Chat History'} onCancel={() => setHistoryOpen(false)} cancelText="Close" okButtonProps={{ hidden: true }}>
    <ConversationList>
      {history?.map(lh => <Conversation key={lh.updated}
        name={<div title={DateUtil.getShortDateTime(lh.updated)}>{lh.topic}</div>}
        onClick={() => switchToHistory(lh)}
      >
        <Conversation.Operations visible>
          <Popconfirm onConfirm={e => {
            e.stopPropagation();
            e.preventDefault();
            deleteConversation(lh.topicId);
          }} onCancel={e => {
            e.stopPropagation();
            e.preventDefault();
          }}
            title={<span>Delete <strong>{lh.topic}</strong> conversation?</span>}>
            <Button className="hover-danger" title="Delete this conversation" type="text" onClick={e => {
              e.preventDefault();
              e.stopPropagation();
            }}><DeleteOutlined /></Button>
          </Popconfirm>
        </Conversation.Operations>
      </Conversation>)}
    </ConversationList>
  </Modal>;
};